import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { useSelectedOrganization } from "../../organization/hooks/useSelectedOrganization";
import { GET_ARTICLES_QUERY_KEY } from "./useListArticles";

export const useDeleteArticle = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    const { selectedOrganization } = useSelectedOrganization();

    return useMutation({
        mutationFn: (id: string) =>
            client.fetchApi<{ success: boolean; message: string }, {}>({
                endpoint: `articles/${id}`,
                method: 'DELETE'
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: GET_ARTICLES_QUERY_KEY(selectedOrganization?.id || '') });
        },
    });
};
